import FormControl from "common/components/FormControl/FormControl";
import FormScrollError from "common/components/FormScrollError/FormScrollError";
import { useMemo, useState } from "react";
import { Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import arrayMutators from "final-form-arrays";
import EditHeader from "common/components/EditHeader/EditHeader";
import useRouter from "common/hooks/use-router";
import HeaderButtonsEdit from "common/components/EditHeader/HeaderButtonsEdit";
import useOrganization from "common/hooks/useOrganization";

function TagForm({ onSubmit, tag }: any) {
  const { t } = useTranslation();
  const { navigate } = useRouter();
  const [errorMessage, setErrorMessage] = useState("");
  const { organization: currentOrganization } = useOrganization();

  const initialValues = useMemo(
    () =>
      tag?.id
        ? {
            ...tag,
          }
        : {
            name: "",
            icon: null,
            organization: currentOrganization?.id || currentOrganization,
          },
    [currentOrganization, tag]
  );

  const onSubmitWrapper = async (values: any) => {
    const res = await onSubmit(values);

    if (res.message) {
      setErrorMessage(res.message);
    }
  };

  return (
    <Form
      onSubmit={onSubmitWrapper}
      mutators={{
        ...arrayMutators,
        setFieldValue: ([field]: any, state: any, utils: any) => {
          utils.changeValue(state, field.field, () => field.value);
        },
      }}
      subscription={{ values: true, submitting: true, pristine: true }}
      initialValues={initialValues}
      render={({ handleSubmit, values }) => {
        return (
          <div className="mx-auto max-w-full py-4 px-4 text-slate-500 text-base">
            {/* Header */}
            <EditHeader
              title={t(tag?.id ? "editItem.tag" : "newItem.tag")}
              subtitle={values.name}
              icon="TagIconOutline"
              errorMessage={errorMessage}
              HeaderButtonsEdit={
                <HeaderButtonsEdit
                  inHeader
                  onSubmit={handleSubmit}
                  onCancel={() => navigate(-1)}
                />
              }
            />
            <form onSubmit={handleSubmit} noValidate>
              <FormScrollError />

              <div className="responsive-flex gap-2 mt-2">
                <div className="md:w-full mb-2 md:mb-0">
                  <div className="flex flex-col gap-2 w-full">
                    <div className="white-box">
                      <div className="responsive-flex gap-4">
                        <div className="flex flex-col w-full">
                          <FormControl
                            name="label"
                            titleKey={t("forms.name")}
                            required
                            containerStyle="flex w-full mb-4"
                            className="text-input"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {
                // JSON.stringify(values)
              }

              <HeaderButtonsEdit
                onSubmit={handleSubmit}
                onCancel={() => navigate("/tags")}
              />
            </form>
          </div>
        );
      }}
    />
  );
}
export default TagForm;
